import firebase from "firebase/app";
import "firebase/auth";

const firebaseStage = {
	apiKey: "AIzaSyAmMa_DmjmZsUO6b3YNMJEV2BB_h4jR8dc",
	authDomain: "empirich-dev.firebaseapp.com",
	projectId: "empirich-dev",
	storageBucket: "empirich-dev.appspot.com",
	messagingSenderId: "927964726320",
	appId: "1:927964726320:web:61c59aa6be64eae9d519f5",
	measurementId: "G-T7E5Z6NK9P",
};

const firebaseProd = {
	apiKey: "AIzaSyDwiuEKc5RobhqQ-GSSqHl38xZrZSamJr0",
	authDomain: "empirich-2.firebaseapp.com",
	projectId: "empirich-2",
	storageBucket: "empirich-2.appspot.com",
	messagingSenderId: "351351687034",
	appId: "1:351351687034:web:9ecb28fd2f8a1d664e78c3",
	measurementId: "G-YXNZ5ETVPX",
};

const firebaseMes = {
	apiKey: "AIzaSyCbslV4n6Z1n1NEqscyXJtVt-Qd0dFvV1w",
	authDomain: "encoded-source-277806.firebaseapp.com",
	databaseURL: "https://encoded-source-277806.firebaseio.com",
	projectId: "encoded-source-277806",
	storageBucket: "encoded-source-277806.appspot.com",
	messagingSenderId: "387332174380",
	appId: "1:387332174380:web:a3d7d900f5403f6d709789",
	measurementId: "G-461SD3R6YJ",
};

export const firebaseApp = () => {
	switch (getStatusStage()) {
		case "production":
			// console.log("[firebase] prod init");
			return firebase.initializeApp(firebaseProd);
		case "test":
			return firebase.initializeApp(firebaseStage);
		case "stage":
			// console.log("[firebase] stage init");
			return firebase.initializeApp(firebaseStage);
		case "mes":
			// console.log("[firebase] mes init");
			return firebase.initializeApp(firebaseProd);
		case "localhost":
			return firebase.initializeApp(firebaseStage);
	}
};

export const MAINANTENCE_MODE = false;


export const LEGACY_STAGE_ENDPOINT = "https://stage.api.empirich.com";
export const HETZNER_STAGE_ENDPOINT = "https://stage.api.empirich.com";
export const STAGE_ENDPOINT = HETZNER_STAGE_ENDPOINT;
export const LEGACY_PROD_ENDPOINT = "https://api.empirich.com";
export const HETZNER_PROD_ENDPOINT = "https://api.empirich.com";

export const PROD_ENDPOINT = HETZNER_PROD_ENDPOINT;
export const STAGE_FRONTEND = "https://stage.empirich.com";
export const PROD_FRONTEND = "https://v2.empirich.com";

interface configApp {
	URL: string;
	MAINANTENCE_MODE: boolean;
	STAGE: STAGE;
}

function getURL(stage: STAGE): string {
	switch (stage) {
		case "production":
			return PROD_ENDPOINT;
		case "mes":
			return PROD_ENDPOINT;
		case "stage":
			return STAGE_ENDPOINT;
		case "localhost":
			return "http://localhost:8000";
		default:
			throw new Error("Non hai settato nulla per questo stage");
	}
}

type STAGE = "production" | "localhost" | "stage" | "test" | "mes";

export const getStatusStage = (): STAGE => import.meta.env.MODE as STAGE;

export const config = (): configApp => {
	if (import.meta.env.MODE === "test") {
		return {
			URL: "/",
			MAINANTENCE_MODE,
			STAGE: "test",
		};
	}

	if (import.meta.env.MODE === "stage" || import.meta.env.MODE === "production")
		return {
			URL: getURL(getStatusStage()),
			MAINANTENCE_MODE,
			STAGE: getStatusStage(),
		};

	throw new Error("env error");
};
